// @flow
import React from 'react';
import injectSheet from 'react-jss';
import cx from 'classnames';

type Props = {
  classes: Object,
  interested: boolean,
  count: number,
  handleClick: (e: SyntheticEvent) => void
};

const InterestIcon = (props: Props) => {
  const {
    classes: c,
    interested = false,
    count = 0,
    handleClick
  } = props;

  const modifiedCount = count >= 1000 ? `${count / 1000}k` : count;

  const style = { color: interested ? 'black' : 'white' };
  const icon = interested ? 'star' : 'star_border';

  return (
    <div className={c.container}>
      <i
        className={cx('material-icons', c.icon)}
        style={style}
        onClick={handleClick}
      >
        {icon}
      </i>
      <span className={c.count}>
        {modifiedCount}
      </span>
    </div>
  );
};

const styles = {
  container: {
    width: '98px',
    height: '30px',
    zIndex: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    userSelect: 'none',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
    '@media(max-width: 768px)': {
      width: '68px',
    }
  },
  count: {
    color: 'white',
    fontSize: '16px',
    margin: '0 8px',
    textAlign: 'center',
    '@media(max-width: 768px)': {
      fontSize: '12px',
    }
  },
  icon: {
    fontSize: '42px',
    margin: '0 8px',
    textAlign: 'center',
    cursor: 'pointer',
    '@media(max-width: 768px)': {
      fontSize: '30px',
    }
  },
};

export default injectSheet(styles)(InterestIcon);
